export function goToStartOfLine(sequencerEngine) {
    let stepNumber = sequencerEngine.getSelectedStep();
    let resolution = sequencerEngine.resolution;
    let numSteps = resolution.numSteps();
    let stepsToGo = stepNumber % numSteps;
    for (let i=0; i < stepsToGo; i++) {
        sequencerEngine.left(false);
    }
    sequencerEngine.cursor.updateRedux();
}

export function downLine(sequencerEngine, updateRedux=true) {
    let numSteps = sequencerEngine.resolution.numSteps();
    for (let i=0; i < numSteps; i++) {
        sequencerEngine.right(false);
    }
    if (updateRedux) {
        sequencerEngine.cursor.updateRedux();
    }
}

export function upLine(sequencerEngine, updateRedux=true) {
    let numSteps = sequencerEngine.resolution.numSteps();
    for (let i=0; i < numSteps; i++) {
        sequencerEngine.left(false);
    }
    sequencerEngine.cursor.updateRedux();
    if (updateRedux) {
        sequencerEngine.cursor.updateRedux();
    }
}
